import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {RemoteConfigProvider, withRemoteConfig} from '@spotify-internal/remote-config-resolver-react';

import {withMarketInfo} from 'context/MarketInfo/MarketInfoProvider';
import {withUserInfo} from 'context/UserInfo/UserInfoProvider';
import resolver from 'lib/shared/experimentation/resolver';
import analytics from 'lib/client/analytics/analytics';
import {marketInfoPropType, userInfoPropType} from 'utils/custom-proptypes';

import {isExperimentValid} from './experimentationUtils';

export const withExperimentation = (experiments = {}, config = {blockRendering: false}) => Comp =>
  withRemoteConfig(configResolver => {
    const props = {};

    Object.entries(experiments).forEach(([propKey, experimentKey]) => {
      // Check for overrides (coming from GET params)
      const overrides = configResolver.overrides;
      if (overrides.has(experimentKey)) {
        props[propKey] = overrides.get(experimentKey) === 'true';
        return;
      }

      // Check for things like market filtering
      if (!isExperimentValid(experimentKey, configResolver.market)) {
        return;
      }

      // Default: a experiment we've asked for will be send to the props based on whether we've resolved or not
      props[propKey] = configResolver.isActive ? configResolver.getBool(experimentKey) : null;
    });
    return props;
  }, config)(Comp);

class ExperimentationProvider extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    userInfo: userInfoPropType,
    marketInfo: marketInfoPropType,
  };

  render() {
    const {userInfo, marketInfo, children} = this.props;

    if (userInfo.data) {
      resolver.resolve({userKey: userInfo.data.username}).then(() => {
        const expProperties = (resolver.configuration && resolver.configuration.properties) || {};
        Object.entries(expProperties).forEach(([key, config]) => {
          // Only send tracking for experiments that is active
          if (isExperimentValid(key, marketInfo.market)) {
            analytics.trackExperiment(key, config.value ? 'experiment' : 'control');
          }
        });
      });
    }

    return <RemoteConfigProvider resolver={resolver}>{children}</RemoteConfigProvider>;
  }
}

export default withUserInfo(withMarketInfo(ExperimentationProvider));
